// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar_main {
    background: linear-gradient(145deg, #eedad8 0%, #f0e8e7 50.5%, #f1f1f1 100%);
    padding: 1rem 1rem;
    width: 300px;
    /* height: 691px; */
    height: 100vh;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    box-shadow: 0px 4px 4px 0px #00000040;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 40px;   
}

.sidebar_main::-webkit-scrollbar {
    display: none;
}

.icon_sidebarClose{
    display: flex;
    justify-content: flex-end;
}

.magnumlog_icon{
    width: 100%;
    height: fit-content;
    padding: 2px 4px 1.5rem 8px;
}
.magnumlog_icon img{
    width: 220px;
    height: 65px;
}

.nav_sidebar{
    gap: 1rem;
}

.active_nav{
    border-color: #234B9A !important;
    background: linear-gradient(90deg, rgba(228, 241, 255, 0.5) 0%, rgba(228, 241, 255, 0.25) 100%);
    color: #234B9A !important;
    /* padding: 12px 8px !important; */
}

.nav_sidebar a{
    padding: 12px 16px;
    color: #000000;
    font-size: 15px;
    font-weight: 500;
    display:flex;
    align-items: center;
    height: 50px;
    width: 230px;
    /* gap: 1rem; */
    text-decoration: none;
    border: 1px solid transparent;
    border-radius: 8px;
    text-transform: capitalize;
}

.dropdown-arrow {
    margin-left: auto;
}


.hideCalnceIcon{
    display: none;
}


.dropdown-side {
    /* padding-left: 15px!important; */
    /* border: none!important; */
    border-color: none!important;
  }
  
  .dropdown-item-side {
    display: flex;
    align-items: center;
    border: none!important;
    border-color: none!important;
  }

  .dropdown-item-side:hover, 
  .dropdown-item-side:active,
  .dropdown-item-side:focus {
    background: none!important;
    color: #234B9A!important;
  }
  
  .dropdown-item-side .dot {
    height: 5px;
    width: 5px;
    background-color: black;
    border-radius: 50%;
  }
  

@media screen and (max-width:1400px) {
   .sidebar_main{
    gap: 20px;
   }
}
@media screen and (max-width:851px) {
    .sidebar_main{
        display: none;
        position: absolute;
        z-index: 1;
        left: 0;
    }
    .hideCalnceIcon{
        display: block;
    }
}
.middle-dot{ 
    font-size: 2rem;
    font-weight: 900;
}
.magnumlog_icon{
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,4EAA4E;IAC5E,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;IACxB,qCAAqC;IACrC,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,+FAA+F;IAC/F,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,6BAA6B;IAC7B,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,aAAa;AACjB;;;AAGA;IACI,kCAAkC;IAClC,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;;;IAGE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,kBAAkB;EACpB;;;AAGF;GACG;IACC,SAAS;GACV;AACH;AACA;IACI;QACI,aAAa;QACb,kBAAkB;QAClB,UAAU;QACV,OAAO;IACX;IACA;QACI,cAAc;IAClB;AACJ;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB","sourcesContent":[".sidebar_main {\n    background: linear-gradient(145deg, #eedad8 0%, #f0e8e7 50.5%, #f1f1f1 100%);\n    padding: 1rem 1rem;\n    width: 300px;\n    /* height: 691px; */\n    height: 100vh;\n    overflow-y: auto;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    box-shadow: 0px 4px 4px 0px #00000040;\n    z-index: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 40px;   \n}\n\n.sidebar_main::-webkit-scrollbar {\n    display: none;\n}\n\n.icon_sidebarClose{\n    display: flex;\n    justify-content: flex-end;\n}\n\n.magnumlog_icon{\n    width: 100%;\n    height: fit-content;\n    padding: 2px 4px 1.5rem 8px;\n}\n.magnumlog_icon img{\n    width: 220px;\n    height: 65px;\n}\n\n.nav_sidebar{\n    gap: 1rem;\n}\n\n.active_nav{\n    border-color: #234B9A !important;\n    background: linear-gradient(90deg, rgba(228, 241, 255, 0.5) 0%, rgba(228, 241, 255, 0.25) 100%);\n    color: #234B9A !important;\n    /* padding: 12px 8px !important; */\n}\n\n.nav_sidebar a{\n    padding: 12px 16px;\n    color: #000000;\n    font-size: 15px;\n    font-weight: 500;\n    display:flex;\n    align-items: center;\n    height: 50px;\n    width: 230px;\n    /* gap: 1rem; */\n    text-decoration: none;\n    border: 1px solid transparent;\n    border-radius: 8px;\n    text-transform: capitalize;\n}\n\n.dropdown-arrow {\n    margin-left: auto;\n}\n\n\n.hideCalnceIcon{\n    display: none;\n}\n\n\n.dropdown-side {\n    /* padding-left: 15px!important; */\n    /* border: none!important; */\n    border-color: none!important;\n  }\n  \n  .dropdown-item-side {\n    display: flex;\n    align-items: center;\n    border: none!important;\n    border-color: none!important;\n  }\n\n  .dropdown-item-side:hover, \n  .dropdown-item-side:active,\n  .dropdown-item-side:focus {\n    background: none!important;\n    color: #234B9A!important;\n  }\n  \n  .dropdown-item-side .dot {\n    height: 5px;\n    width: 5px;\n    background-color: black;\n    border-radius: 50%;\n  }\n  \n\n@media screen and (max-width:1400px) {\n   .sidebar_main{\n    gap: 20px;\n   }\n}\n@media screen and (max-width:851px) {\n    .sidebar_main{\n        display: none;\n        position: absolute;\n        z-index: 1;\n        left: 0;\n    }\n    .hideCalnceIcon{\n        display: block;\n    }\n}\n.middle-dot{ \n    font-size: 2rem;\n    font-weight: 900;\n}\n.magnumlog_icon{\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
